import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              草民影院最新资讯和更新动态，随时了解平台变化
            </p>
          </div>

          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-3 md:left-[17px] top-1 bottom-1 w-0.5 bg-background-300/60"></div>

            <div className="space-y-6">
              {updates.map((item, idx) => (
                <div key={idx} className="relative">
                  <div className="absolute -left-[22px] md:-left-[25px] top-1.5 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100"></div>

                  <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xs text-foreground-400">{item.date}</span>
                      <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}